import { colorList } from 'utils/colors'
import { ThemedValues } from 'styles/themed'
import { StyleSheet } from 'react-native'

const DatepickerStyles = StyleSheet.create({
    header: {
        backgroundColor: colorList.PRIMARY.primary,
        borderBottomColor: colorList.GREY.primary,
        borderBottomWidth: 1,
    },
    month_selector_label: {
        color: colorList.WHITE.primary
    },
    year_selector_label: {
        color: colorList.WHITE.primary
    },
    button_next: {
        color: colorList.WHITE.primary
    },
    button_previous: {
        color: colorList.WHITE.primary
    },

    outside_label: {
        color: colorList.TEXT.primary
    },

    range_start_label: {
        color: colorList.TEXT.primary
    },
    range_end_label: {
        color: colorList.TEXT.primary
    },
    range_middle_label: {
        color: colorList.TEXT.primary
    },
    range_fill: {
        backgroundColor: colorList.PRIMARY.light,
        borderRadius: ThemedValues.borderRadius,
    },

    // Year selector
    year_label: {
        color: colorList.TEXT.primary
    },
    year: {
        borderRadius: ThemedValues.borderRadius,
        color: colorList.TEXT.primary,
        borderColor: colorList.GREY.primary,
        borderWidth: 1,
    },
    active_year: {
        backgroundColor: colorList.PRIMARY.light,
        color: colorList.PRIMARY.primary,
        borderColor: colorList.PRIMARY.primary,
        borderWidth: 1,
    },

    // Month selector
    month_label: {
        color: colorList.TEXT.primary
    },
    month: {
        borderRadius: ThemedValues.borderRadius,
        color: colorList.TEXT.primary,
        borderColor: colorList.GREY.primary,
        borderWidth: 1,
    },
    selected_month: {
        backgroundColor: colorList.PRIMARY.light,
        color: colorList.PRIMARY.primary,
        borderColor: colorList.PRIMARY.primary,
        borderWidth: 1,
    },
    selected_month_label: {
        color: colorList.WHITE.primary
    },

    // Day selector
    day_label: {
        color: colorList.TEXT.primary
    },
    day: {
        borderRadius: ThemedValues.borderRadius,
        color: colorList.TEXT.primary,
        borderColor: colorList.GREY.primary,
        borderWidth: 1,
    },
    active_day: {
        backgroundColor: colorList.PRIMARY.light,
        color: colorList.PRIMARY.primary,
        borderColor: colorList.PRIMARY.primary,
        borderWidth: 1,
    },

    today: { 
        borderColor: colorList.PRIMARY.light, 
        borderWidth: 1,
    },
    today_label: {
        color: colorList.PRIMARY.primary
    },

    selected: {
            backgroundColor: colorList.PRIMARY.primary
    },
    selected_label: { 
        color: colorList.WHITE.primary 
    },
})

export const DatepickerContainerStyles = StyleSheet.create({
    picker: {
        width: '100%',
    },

    headerStyle: {
        backgroundColor: colorList.PRIMARY.primary
    },
    closeStyle: {
        color: colorList.WHITE.primary
    },
    modalStyle: {
        width: '100%',
        maxWidth: 600,
    }
})

export default DatepickerStyles